<template>
	<div>
		<v-btn
			:loading="qrLoading"
			class="qr-btn"
			color="orange"
			fixed
			bottom
			right
			dark
			fab
			@click="qrcode"
		>
			<v-icon>fa-qrcode</v-icon>
		</v-btn>

		<nav-snackbar v-model="qrError" top>{{
			strings.install.qrError
		}}</nav-snackbar>
	</div>
</template>

<style lang="scss" scoped>
.qr-btn {
	// TODO: Use $vuetify.application.bottom to get correct footer height
	//       instead of hard-coding footer height
	bottom: 44px;
	margin-bottom: 16px;
}
</style>

<script>
import { mapActions } from "vuex";

import strings from "@/utils/strings";

export default {
	data: () => ({
		strings,
		qrLoading: false,
		qrError: false,
	}),

	methods: {
		...mapActions({
			readQR: "install/readQR",
		}),

		async qrcode() {
			this.qrLoading = true;
			try {
				// Read QR and set active community system
				const { community, system } = await this.readQR();
				return this.$router.push({
					path: `/install/${community.id}/${system.id}`,
				});
			} catch (e) {
				this.qrError = true;
			} finally {
				this.qrLoading = false;
			}
		},
	},
};
</script>
